import axios from 'axios';
import URLUtil from '../../utils/URLUtil';
import {BOOKING_TYPE_PACKAGEDEAL, BUYABLE_TYPE_PACKAGEDEAL, ENTRY_DURATION_DAY, ENTRY_DURATION_EVENING, PAYMENT_TYPE_CADEAUBON, PAYMENT_TYPE_IDEAL, PAYMENT_TYPE_ZERO} from '../../AppConstants.js';
import DataLayerUtil from '../../utils/DataLayerUtil.js';
import * as debug_actions from '../debug/actions_debug.svelte.js';
import AppConfig from '../../AppConfig.js';
import {page_json, progress} from '../progress/feature.progress.svelte.js';
import {widgets, widgets_json} from '../widgets/feature.widgets.svelte.js';
import InputUtil from '../../utils/InputUtil.js';
import {booker} from '../booker/feature.booker.svelte.js';
import * as booker_select from '../booker/booker.scenarios.select.svelte.js';
import {booking} from '../booking/feature.booking.svelte.js';
import * as booking_select_export from '../booking/booking.scenarios.select.export.svelte.js';
import * as booking_actions from '../booking/actions_booking.svelte.js';

export async function fetchDog()
{
  debug_actions.debugAddLogFlow('remote', 'fetchDog');

  try
  {
    const response = await axios.get('https://dog.ceo/api/breeds/image/random');
    return response.data.message;
  } catch (error)
  {
    console.error('Error logging in customer:', error);
    //throw error;
  }
}

export async function validateGiftcard(sGiftcardCode)
{
  debug_actions.debugAddLogFlow('remote', 'validateGiftcard', {sGiftcardCode});

  if ( AppConfig.bDebugUseFakeAjaxCalls )
  {
    return new Promise((resolve) => {
      setTimeout(() => {
        // nodig voor lokale test - kan online geen kwaad want Elli verrekent hem niet
        if ( sGiftcardCode === '1234567890123' )
        {
          resolve({
            success: true,
            iValueCents: 2500, // €25.00
            message: 'Cadeaubon is geldig'
          });
        }
        else
        {
          resolve({
            success: false,
            errorMessage: 'Deze cadeaubon code is niet geldig of al gebruikt.'
          });
        }
      }, 1000); // Simulate network delay
    });
  }

  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  const sTargetUrl = sBaseUrl + '/resdata/getGiftcardValue/';

  const oData = {
    code: sGiftcardCode,
    ch: Date.now()
  };

  try
  {
    const response = await axios.post(sTargetUrl, oData);
    return response.data;
  } catch (error)
  {
    console.error('Error validating giftcard:', error);
    throw error;
  }
}

export async function fetchPageData(fnCallback)
{
  debug_actions.debugAddLogFlow('remote', 'fetchPageData');
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/start/';

  if ( AppConfig.bDebugUseFakeAjaxCalls )
  {
    // lokaal moet de dev server bij de public map kunnen komen zonder CORS issues tussen de dev server op localhost:5173 en localhost
    // daarom hebben we in de vite.config.js een proxy ingesteld
    sTargetUrl = sBaseUrl + '/resdata/start';
    // sTargetUrl = '/resdata/start/'; // NB die slash aan het einde is verplicht anders krijgen we van Silverstripe een redirect terug en Vite volgt die redirect niet
  }

// console.log('TARRRRRGET IS ', sTargetUrl);
  const oData = {
    ch: Date.now()
  };

  const response = await axios.get(sTargetUrl, {params: oData}).then(response => {

    //console.log(response.data);

    // App.Shop.Svelte doet hierna de initiele init
    // op dit moment parkeer ik alles tijdelijk in page_json
    // zodat het zometeen verwerkt kan worden
    // veel van de data hoeft niet per se reactive state te zijn dus mocht dat zwaar blijken
    // dan zouden we ook kunnen overwegen sommige dingen niet over te zetten naar de losse features
    // maar elke featurelaag ook een node in page_json te laten gebruiken die statisch blijft na de eerste load
    page_json.data = response.data;
    progress.bWasJSONDataFromPageReceived = true;

    // eens kijken of dingen betrouwbaarder zijn als ze gewoon direct worden afgehandeld
    //alert('App.Debug.svelte gaat de InputUtil een slinger geven');
    //window.console.log('page_json.data is bijgewerkt en we gaan nu gaat de InputUtil een slinger geven', JSON.stringify(page_json));
    InputUtil.updateInitialStateWithExternalInput();

    if ( typeof fnCallback === 'function' )
    {
      fnCallback();
    }
  })
    .catch(error => console.error(error));
}

export async function fetchWidgetData(fnCallback)
{
  debug_actions.debugAddLogFlow('remote', 'fetchWidgetData');
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/widgetStart/';

  // omdat widgets niet met de vite dev server ontwikkeld worden moet er hier localhost wel een segment tussen
  if ( window.location.hostname === 'localhost' && window.location.port === '' )
  {
    sTargetUrl = sBaseUrl + '/lifestyleresorts.nl/resdata/widgetStart/';
  }

  const oData = {
    ch: Date.now()
  };

  const response = await axios.get(sTargetUrl, {params: oData}).then(response => {

    //console.log(response.data);

    // op dit moment parkeer ik alles tijdelijk in page_json
    // zodat het zometeen verwerkt kan worden
    // veel van de data hoeft niet per se reactive state te zijn dus mocht dat zwaar blijken
    // dan zouden we ook kunnen overwegen sommige dingen niet over te zetten naar de losse features
    // maar elke featurelaag ook een node in page_json te laten gebruiken die statisch blijft na de eerste load
    widgets_json.shared = response.data;
    widgets.bWasBaseJSONForWidgetsReceived = true;

    // eens kijken of dingen betrouwbaarder zijn als ze gewoon direct worden afgehandeld
    //alert('App.Debug.svelte gaat de InputUtil een slinger geven');
    //window.console.log('page_json.data is bijgewerkt en we gaan nu gaat de InputUtil een slinger geven', JSON.stringify(page_json));
    InputUtil.updateWidgetsSharedStateWithExternalInput();

    if ( typeof fnCallback === 'function' )
    {
      fnCallback();
    }
  })
    .catch(error => console.error(error));
}

export async function fetchCalendar(fnCallback)
{
  // deze call wordt de eerste keer vanuit AppShop aangeroepen na het parsen van de start-data
  // en vervolgens na het switchen van de hoofdknoppen in stap 1 (type boeking)
  // omdat je daarmee eventuele presets kan resetten en dus een ander soort kalender nodig hebt

  // clear eventuele eerdere kalender data
  // dat moet hier omdat het kan zijn dat we eerder al een kalender voor de hoofdentree hebben opgevraagd
  // en net geswitched zijn naar 'ik wil een arrangement'. Als je een arrangement wil zonder preset arrangement
  // dan willen we in de kalender geen prijzen tonen omdat we nog niet weten welk arrangement je wil.
  // Verderop in deze functie gaan we de afhaken voordat we de call maken. Hier maken we alvast de data leeg.
  progress.aCalendarDates = [];

  debug_actions.debugAddLogFlow('remote', 'fetchCalendar');
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/calendar/?source=res';

  // omdat widgets niet met de vite dev server ontwikkeld worden moet er hier localhost wel een segment tussen
  if ( window.location.hostname === 'localhost' && window.location.port === '' )
  {
    sTargetUrl = sBaseUrl + '/lifestyleresorts.nl/resdata/calendar/?source=res';
  }

  if ( AppConfig.bDebugUseFakeAjaxCalls )
  {
    // lokaal moet de dev server bij de public map kunnen komen zonder CORS issues tussen de dev server op localhost:5173 en localhost
    // daarom hebben we in de vite.config.js een proxy ingesteld
    //sTargetUrl = sBaseUrl + '/resdata/start';
    //sTargetUrl = '/resdata/start/'; // NB die slash aan het einde is verplicht anders krijgen we van Silverstripe een redirect terug en Vite volgt die redirect niet
  }

  // cache buster
  const oData = {
    ch: Date.now()
  };

  // toevoegen dat we meegeven naar de server wat we willen
  if ( booking.iUseThisEntryIDForFirstPerson )
  {
    // preset (actie)entree zijn we wel in geinteresseerd.. een eventueel preset product negeren we... dan wil je gewoon een entree en boeken we wel dat product in maar dat komt niet in de kalender)
    oData.entry = booking.iUseThisEntryIDForFirstPerson;
  }
  else if ( booking.bShowListOfPackageDeals === true && booking.iPreselectedPackageDealID !== false )
  {
    oData.arr = booking.iPreselectedPackageDealID;
  }
  else if ( booking.sBookingType === BOOKING_TYPE_PACKAGEDEAL && booking.iPreselectedPackageDealID === false )
  {
    // we gaan later een arrangement kiezen dus kunnen we nog geen prijzen opvragen.. toon kalender zonder prijzen
    // maar we willen wel de infotekstjes bij de dagen
    oData.arr = 'not_selected_yet';
  }
  else if ( booking.bShowListOfPackageDeals === false && booking.sPreferredPartOfTheDay === ENTRY_DURATION_DAY )
  {
    //niets meegeven: main entree kalender opvragen
  }
  else if ( booking.bShowListOfPackageDeals === false && booking.sPreferredPartOfTheDay === ENTRY_DURATION_EVENING )
  {
    //avondentree kalender opvragen.. die id hebben we hard coded in AppConfig
    oData.entry = AppConfig.aEntreeAvondExternalIDs[0];
  }

  const response = await axios.get(sTargetUrl, {params: oData}).then(response => {

    if ( typeof response !== 'undefined' && typeof response.data !== 'undefined' && typeof response.data.aDays !== 'undefined' )
    {
      progress.aCalendarDates = response.data.aDays;

      if ( booking.sPreselectedDate !== false )
      {
        booking_actions.setArrivalDate(booking.sPreselectedDateDay, booking.sPreselectedDateMonth, booking.sPreselectedDateYear, true);
      }
    }

    if ( typeof fnCallback === 'function' )
    {
      fnCallback();
    }
  })
    .catch(error => console.error(error));
}

export async function fetchCalendarForWidgets(fnCallback)
{
  // Deze call heeft aanzienlijk minder return data vanuit PHP nodig dan de reserveerstraatversie.

  // clear eventuele eerdere kalender data

  progress.aCalendarDates = [];

  debug_actions.debugAddLogFlow('remote', 'calendarForWidgets');
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/calendarForWidgets/';

  // omdat widgets niet met de vite dev server ontwikkeld worden moet er hier localhost wel een segment tussen
  if ( window.location.hostname === 'localhost' && window.location.port === '' )
  {
    sTargetUrl = sBaseUrl + '/lifestyleresorts.nl/resdata/calendarForWidgets/';
  }

  if ( AppConfig.bDebugUseFakeAjaxCalls )
  {
    // lokaal moet de dev server bij de public map kunnen komen zonder CORS issues tussen de dev server op localhost:5173 en localhost
    // daarom hebben we in de vite.config.js een proxy ingesteld
    //sTargetUrl = sBaseUrl + '/resdata/calendarForWidgets';
    //sTargetUrl = '/resdata/calendarForWidgets/'; // NB die slash aan het einde is verplicht anders krijgen we van Silverstripe een redirect terug en Vite volgt die redirect niet
  }

  // cache buster
  const oData = {
    ch: Date.now()
  };

  // toevoegen dat we meegeven naar de server wat we willen
  if ( booking.iUseThisEntryIDForFirstPerson )
  {
    // present (actie)entree zijn we wel in geinteresseerd.. een eventuel preset product negeren we... dan wil je gewoon een entree en boeken we wel dat product in maar dat komt niet in de kalender)
    oData.entry = booking.iUseThisEntryIDForFirstPerson;
  }
  else if ( booking.bShowListOfPackageDeals === true && booking.iPreselectedPackageDealID !== false )
  {
    oData.arr = booking.iPreselectedPackageDealID;
  }
  else if ( booking.sBookingType === BOOKING_TYPE_PACKAGEDEAL && booking.iPreselectedPackageDealID === false )
  {
    // we gaan later een arrangement kiezen dus kunnen we nog geen prijzen opvragen.. toon kalender zonder prijzen
    // maar we willen wel de infotekstjes bij de dagen
    oData.arr = 'not_selected_yet';
  }
  else if ( booking.bShowListOfPackageDeals === false && booking.sPreferredPartOfTheDay === ENTRY_DURATION_DAY )
  {
    //niets meegeven: main entree kalender opvragen
  }
  else if ( booking.bShowListOfPackageDeals === false && booking.sPreferredPartOfTheDay === ENTRY_DURATION_EVENING )
  {
    //avondentree kalender opvragen.. die id hebben we hard coded in AppConfig
    oData.entry = AppConfig.aEntreeAvondExternalIDs[0];
  }

  const response = await axios.get(sTargetUrl, {params: oData}).then(response => {

    if ( typeof response !== 'undefined' && typeof response.data !== 'undefined' && typeof response.data.aDays !== 'undefined' )
    {
      // hack om ontbrekende prijsregels op te vangen
      if ( booking.bShowListOfPackageDeals === true && booking.iPreselectedPackageDealID !== false )
      {
        let oParsedDates = {};

        let oDayConfig;
        for ( let sKey in response.data.aDays )
        {
          oDayConfig = response.data.aDays[sKey];

          if ( typeof oDayConfig.p === 'undefined' )
          {
            oDayConfig.p = 5900;
          }

          oParsedDates[sKey] = oDayConfig;
        }

        progress.aCalendarDates = oParsedDates;
      }
      else
      {
        progress.aCalendarDates = response.data.aDays;
      }

      if ( booking.sPreselectedDate !== false )
      {
        booking_actions.setArrivalDate(booking.sPreselectedDateDay, booking.sPreselectedDateMonth, booking.sPreselectedDateYear, true);
      }
    }

    if ( typeof fnCallback === 'function' )
    {
      fnCallback();
    }
  })
    .catch(error => console.error(error));
}

export async function fetchProductAvailability(iProductID, sStartDate, sEndDate, iArrivalTime, iDepartureTime, aBookedProductsAndTimes, bUseDummyEndpoint = false)
{
  debug_actions.debugAddLogFlow('remote', 'fetchProductAvailability', {iProductID, sStartDate, sEndDate, iArrivalTime, iDepartureTime, aBookedProductsAndTimes});
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/availability/';

  if ( AppConfig.bDebugUseFakeAjaxCalls || bUseDummyEndpoint === true )
  {
    // lokaal moet de dev server bij de public map kunnen komen zonder CORS issues tussen de dev server op localhost:5173 en localhost
    // daarom hebben we in de vite.config.js een proxy ingesteld die URLs naar public laadt vanaf localhost/lifestyleresorts.nl
    //sTargetUrl = sBaseUrl + '/public/debug/beschikbaarheid_01.html?v=' + Date.now();
  }

  const oData = {
    ch: Date.now(),
    p: iProductID,
    d: sStartDate,
    ta: iArrivalTime,
    td: iDepartureTime,
    b: aBookedProductsAndTimes
  };

  const response = await axios.get(sTargetUrl, {params: oData});

  //window.console.log('TIMING - fetchProductAvailability');
  return response.data;
}

export async function fetchRestaurantProductAvailability(sStartDate, sEndDate, iArrivalTime, iDepartureTime, aBookedProductsAndTimes, bUseDummyEndpoint = false)
{
  debug_actions.debugAddLogFlow('remote', 'fetchRestaurantProductAvailability', {sStartDate, sEndDate, iArrivalTime, iDepartureTime, aBookedProductsAndTimes});
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/availabilityRestaurant/';

  if ( AppConfig.bDebugUseFakeAjaxCalls || bUseDummyEndpoint === true )
  {
    // lokaal moet de dev server bij de public map kunnen komen zonder CORS issues tussen de dev server op localhost:5173 en localhost
    // daarom hebben we in de vite.config.js een proxy ingesteld die URLs naar public laadt vanaf localhost/lifestyleresorts.nl
    //sTargetUrl = sBaseUrl + '/public/debug/beschikbaarheid_01.html?v=' + Date.now();
  }

  const oData = {
    ch: Date.now(),
    d: sStartDate,
    ta: iArrivalTime,
    td: iDepartureTime,
    b: aBookedProductsAndTimes
  };

  const response = await axios.get(sTargetUrl, {params: oData});

  //window.console.log('TIMING antwoord fetchRestaurantProductAvailability', response);
  return response.data;
}

export async function fetchPackageDeals(sStartDate, sEndDate, iArrivalTime, iDepartureTime, bUseDummyEndpoint = false)
{
  debug_actions.debugAddLogFlow('remote', 'fetchPackageDeals', {sStartDate, sEndDate, iArrivalTime, iDepartureTime});
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/packagedeals/';

  if ( AppConfig.bDebugUseFakeAjaxCalls || bUseDummyEndpoint === true )
  {
    // lokaal moet de dev server bij de public map kunnen komen zonder CORS issues tussen de dev server op localhost:5173 en localhost
    // daarom hebben we in de vite.config.js een proxy ingesteld die URLs naar public laadt vanaf localhost/lifestyleresorts.nl
    sTargetUrl = sBaseUrl + '/public/debug/arrangementen_01.html?v=' + Date.now();
  }

  const oData = {
    ch: Date.now(),
    // sTreatmentType: action.sTreatmentType,
    sTreatmentType: BUYABLE_TYPE_PACKAGEDEAL,
    sStartDate: sStartDate,
    sEndDate: sEndDate,
    iArrivalTime: iArrivalTime,
    iDepartureTime: iDepartureTime,
    pa: booking.iPreselectedPackageDealID
    // pc: booking.iPreselectedTreatmentSubcat,
  };

  const response = await axios.get(sTargetUrl, {params: oData});

  //window.console.log('TIMING - fetchPackageDeal');
  return response.data;
}

export async function fetchTreatments(sStartDate, sEndDate, iArrivalTime, iDepartureTime, bUseDummyEndpoint = false)
{
  //window.console.log("HIER! fetchTreatments");
  debug_actions.debugAddLogFlow('remote', 'fetchTreatments');
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/products/';

  if ( AppConfig.bDebugUseFakeAjaxCalls || bUseDummyEndpoint === true )
  {
    // lokaal moet de dev server bij de public map kunnen komen zonder CORS issues tussen de dev server op localhost:5173 en localhost
    // daarom hebben we in de vite.config.js een proxy ingesteld die URLs naar public laadt vanaf localhost/lifestyleresorts.nl
    sTargetUrl = sBaseUrl + '/public/debug/behandelingen_01.html?v=' + Date.now();
  }

  try
  {
    // todo - die tijden hieronder werken nu niet omdat we we /products call al na de kalender doen
    // dit gaan we nog aanpassen en dan moeten onderstaande variabelen weer aan.. de serverkant ondersteunt de tijden
    const oRemoteResponse = await axios.get(sTargetUrl, {
      params: {
        ch: Date.now(),
        sStartDate: sStartDate,
        sEndDate: sEndDate,
        iArrivalTime: 900,
        // iArrivalTime: iArrivalTime,
        // iDepartureTime: iDepartureTime,
        iDepartureTime: 2359,
        pp: booking.iPreselectedTreatmentID
      }
    });

    //window.console.log('TIMING - fetchPackageDeal');
    return oRemoteResponse.data;
  } catch (error)
  {
    //throw error;
  }
}

export async function fetchAddress(sPostalCode, sHouse1, sHouse2, fnCallback)
{
  // window.console.log("HIER! fetchAddress", sPostalCode, sHouse1, sHouse2);
  debug_actions.debugAddLogFlow('remote', 'fetchAddress');
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/postcode/';

  try
  {
    const oRemoteResponse = await axios.get(sTargetUrl, {
      params: {
        pc: sPostalCode,
        nr: sHouse1
      }
    }).then(response => {
      if ( typeof fnCallback === 'function' )
      {
        fnCallback(response.data);
      }

      return response.data;
    }).catch(error => console.error(error));

  } catch (error)
  {
    //throw error;
  }
}

/**
 * Fetch customer ID based on email and password.
 * @param {string} sEmail - Customer's email.
 * @param {string} sPassword - Customer's password.
 * @param fnCallback
 * @returns {Promise<object>} Customer data.
 */
export async function fetchCustomerID(sEmail, sPassword, fnCallback)
{
  debug_actions.debugAddLogFlow('remote', 'fetchCustomerID', {sEmail, sPassword});
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();
  let sTargetUrl = sBaseUrl + '/resdata/account/';

  try
  {
    return await axios.post(sTargetUrl, {
      params: {
        email: sEmail,
        password: sPassword
      }
    }).then(response => {

      if ( typeof fnCallback === 'function' )
      {
        fnCallback();
      }

      const iRelationID = response.data.iRelationID;

      if ( typeof (iRelationID) !== 'undefined' )
      {
        DataLayerUtil.bForceSetLoggedInTrue = true;
      }

      // zie booker_actions.setLoggedInCustomerData
      return response.data;
    }).catch(error => console.error(error));
  } catch (error)
  {
    // progress.bIsFetchingLogin = false;
    console.error('Error fetching customer ID:', error);
    throw error;
  }
}

export async function fetchCheckBadenkaartValue(sDate, sBadenkaartCode, iSelectedEntryID, sArrivalDate)
{
  // WAARSCHIJNLIJK WORDT DIT NU NIET GEBRUIKT
  debug_actions.debugAddLogFlow('remote', 'fetchCheckBadenkaartValue', {sDate});
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();

  try
  {
    const oResponse = await axios.post(`${sBaseUrl}getBadenkaartValue`, {
      params: {
        sBadenkaartCode: sBadenkaartCode,
        iSelectedEntryID: iSelectedEntryID,
        sArrivalDate: sArrivalDate
      }
    });

    return oResponse;
  } catch (error)
  {
    console.error('Error logging remote:', error);
    //throw error;
  }
}

export async function fetchBook()
{
  debug_actions.debugAddLogFlow('remote', 'fetchBook');
  const sBaseUrl = URLUtil.getCurrentPageRelativeLinkWithoutAction();

  let sPaymentMethod = booker.sPaymentMethod;

  if ( sPaymentMethod === PAYMENT_TYPE_ZERO )
  {
    if ( booking.iValidGiftcardValue > 0 )
    {
      sPaymentMethod = PAYMENT_TYPE_CADEAUBON; //Volledig betaald met een cadeaubon zonder restbedrag
    }
  }

  if ( !sPaymentMethod )
  {
    // helemaal niets ingesteld, ook niet zero of onsite.. dan terugvallen op iDeal
    sPaymentMethod = PAYMENT_TYPE_IDEAL;
  }

  let sTargetUrl = sBaseUrl + '/resdata/book/';

  const aData = {};
  aData.input_nth_submit_attempt = progress.iSubmitToServerCounter;
  aData.input_was_redirected_to_payment_provider_before_now = progress.bWasRedirectedToPaymentProviderBeforeNow ? 'true' : 'false';
  aData.input_confirm_sex = booker.sTitle;
  aData.input_name1 = booker.sName1;
  aData.input_name2 = booker.sName2;
  aData.input_name3 = booker.sName3;
  aData.input_email = booker.sEmail;
  aData.input_mobile = booker.sTel;
  aData.input_postalcode = booker.sPostalcode;
  aData.input_housenr = booker.sHouse1;
  aData.input_housenr_addition = booker.sHouse2;
  aData.input_street = booker.sStreet;
  aData.input_city = booker.sTown;
  aData.input_comments_content = booker_select.getMergedManualAndGeneratedComments();
  aData.order = booking_select_export.getBookingExportJSON();
  aData.payment_method = sPaymentMethod;
  aData.payment_issuer_id = booker.sPaymentBrand;
  aData.input_newsletter = booker.bNewsletter ? 'true' : 'false';
  aData.input_makeaccount = booker.bAccount ? 'true' : 'false';
  aData.html_order = document.querySelector('.bon-outer')?.innerHTML || '';

  const aValidGiftcardCodes = booking.lValidGiftcardCodes || [];
  aData.input_giftcardcode = JSON.stringify(aValidGiftcardCodes.map((code) => code.sCode));

  const aValidBadenkaartCodes = booking.lValidBadenkaartCodes || [];
  aData.input_badenkaartcode = JSON.stringify(aValidBadenkaartCodes.map((code) => code.sCode));

  if ( booking.bWantsDinner )
  {
    aData.input_prefered_dinner_time = booking.sPreferredDinnerTime;
  }

  aData.input_giftcardvalue = booking.iValidGiftcardValue;
  //aData.input_badenkaartvalue = booking.iValidBadenkaartValue;
  aData.stay_logged_in = booker.bStayLoggedIn;
  aData.input_customerid = booker.iRelationID; // wordt op de server gecheckt tegen de sessie id

  try
  {
    const oRemoteResponse = await axios.post(sTargetUrl, aData);

    //window.console.log('book oRemoteResponse:', oRemoteResponse);
    return oRemoteResponse.data;

  } catch (error)
  {
    //throw error;
    //window.console.log('network error', error);

    if ( typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' )
    {
      window.console.log('network error', error.response.data);
      jQuery('html').html(error.response.data);
    }
  }

}
